module.exports = __webpack_public_path__ + "public/img/09.996dd5cc.png";